<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '800px' }"
    header="Fomulário de Grupos"
    :modal="true"
    @hide="hideDialog"
    class="p-fluid"
  >
    <div class="field">
      <label for="description">Descrição</label>
      <InputText
        id="description"
        v-model="v$.group.description.$model"
        maxlength="100"
        placeholder="Digite a descrição"
        :class="{ 'p-invalid': submitted && v$.group.description.$invalid }"
      />
      <small class="p-error" v-if="submitted && v$.group.description.$invalid"
        >Descrição é obrigatório.</small
      >
    </div>

    <label for="nome">Permissões do Grupo</label>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-col-12" style="padding: 5px">
        <Listbox
          v-model="v$.group.permissions.$model"
          :options="permissions"
          :multiple="true"
          :filter="true"
          optionLabel="description"
          listStyle="max-height:350px"
          filterPlaceholder="DIGITE O NOME DA PERMISSÃO."
          emptyFilterMessage="Nenhum Resultado..."
          emptyMessage="Nenhum Resultado..."
          :class="{
            'p-invalid': submitted && v$.group.permissions.$invalid,
          }"
        >
          <template #header>
            <div style="padding: 15px">
              <Checkbox
                id="binary"
                v-model="selectedAllPermission"
                :binary="true"
                @click="allPermissoes()"
                class="p-mr-1"
              />
              <small>Todas as Permissões</small>
            </div>
          </template>
          <template #option="slotProps">
            <div class="product-list-detail">
              <i class="pi pi-unlock product-category-icon p-mr-3"> </i>
              <span class="product-category">
                {{ slotProps.option.description.replace("ROLE_", "") }}.</span
              >
            </div>
          </template>
        </Listbox>
        <small class="p-error" v-if="submitted && v$.group.permissions.$invalid"
          >Permissão é obrigatório.</small
        >
      </div>
    </div>

    <template #footer>
      <Button
        label="Salvar"
        class="p-button"
        icon="pi pi-check"
        @click="send(!v$.group.$invalid)"
      />
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button p-button-text"
        @click="hideDialog"
      />
    </template>
  </Dialog>
</template>

<script>
//Models
import Group from "../../../models/group";

//Services
import GroupService from "../../../service/group/group_service";
import PermissionService from "../../../service/permission/permission";

//VALIDATIONS
import { useVuelidate } from "@vuelidate/core";

export default {
  props: ["groupsSelected"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      submitted: false,
      group: new Group(),
      groupService: new GroupService(),

      selectedAllPermission: false,
      permissionService: new PermissionService(),
      permissions: [],
    };
  },
  created() {},
  mounted() {
    this.findAllPermissions();
  },
  validations() {
    return {
      group: new Group().validations(),
    };
  },
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.groups.dialogForm;
        if (value === true) this.getData();
        return value;
      },
      set(value) {
        this.$store.state.views.groups.dialogForm = value;
      },
    },
  },
  methods: {
    send(isFormValid) {
      this.submitted = true;
      if (isFormValid) {
        if (this.group.id) {
          this.update();
        } else {
          this.create();
        }
      } else {
        return;
      }
    },
    create() {
      this.submitted = true;
      this.groupService
        .create(this.group)
        .then((data) => {
          if (data.status === 201) {
            this.$msgSuccess(data);
            this.$emit("findAll");
            this.hideDialog();
          }
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    update() {
      this.submitted = true;
      this.groupService
        .update(this.group)
        .then((data) => {
          if (data.status === 200) {
            this.$msgSuccess(data);
            this.$emit("findAll");
            this.hideDialog();
          }
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    allPermissoes() {
      if (this.selectedAllPermission === false) {
        this.group.permissions = this.permissions;
      } else {
        this.group.permissions = null;
      }
    },
    findAllPermissions() {
      this.permissionService
        .findAll()
        .then((data) => {
          this.permissions = data;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$msgWarn(null);
          }
        });
    },
    hideDialog() {
      this.group = new Group();
      this.submitted = false;
      this.visibleDialog = false;
    },
    getData() {
      this.group = this.groupsSelected;
    },
  },
};
</script>
<style scoped></style>
